import React from 'react';
import { theme } from '@fiverr-private/theme';

interface SellerLevelIcon {
  color?: 'currentColor' | 'empty';
}

const SellerLevelDiamondIcon = ({ color = 'currentColor' }: SellerLevelIcon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    width={10}
    height={10}
    fill={color === 'empty' ? theme.colors.grey_400 : theme.colors.currentColor}
  >
    <path d="M4.839.22a.2.2 0 0 1 .322 0l1.942 2.636a.2.2 0 0 0 .043.043L9.782 4.84a.2.2 0 0 1 0 .322L7.146 7.105a.2.2 0 0 0-.043.043L5.161 9.784a.2.2 0 0 1-.322 0L2.897 7.148a.2.2 0 0 0-.043-.043L.218 5.163a.2.2 0 0 1 0-.322l2.636-1.942a.2.2 0 0 0 .043-.043L4.839.221Z" />
  </svg>
);

SellerLevelDiamondIcon.displayName = 'SellerLevelDiamondIcon';

export default SellerLevelDiamondIcon;
